import React from 'react';
import { Grid, Typography, CircularProgress } from '@material-ui/core';
import { AiOutlineDownload } from 'react-icons/ai';

const linkStyle = {
  textDecoration: 'none',
  color: 'black',
  cursor: 'pointer',
};

export default function ExcelDownloadButton({
  downloadExcelURL,
  loading,
  onGenerate,
  seasonName,
  style,
}) {
  return (
    <Grid
      container
      justifyContent="center"
      onClick={() => !downloadExcelURL && !loading && onGenerate()}
      style={{
        position: 'relative',
        cursor: !loading && !downloadExcelURL ? 'pointer' : undefined,
        ...style,
      }}
    >
      {loading ? (
        <Typography
          display="inline"
          style={{ marginRight: 10 }}
          variant="body2"
        >
          Preparing order...{' '}
          <CircularProgress size={12} style={{ marginLeft: 5 }} />
        </Typography>
      ) : (
        <>
          <Typography style={{ marginRight: 10 }} variant="body2">
            {downloadExcelURL ? 'Excel Ready' : 'Download Order'}
          </Typography>
          <AiOutlineDownload
            size={16}
            color="black"
            style={{ marginTop: 2, cursor: 'pointer' }}
          />
          <span style={{ fontSize: 12 }}>
            {' '}
            {downloadExcelURL ? (
              <a
                href={downloadExcelURL}
                style={linkStyle}
                download={`FARM US - ${seasonName}.xlsx`}
              >
                XLS{' '}
              </a>
            ) : (
              <span style={linkStyle}>XLS </span>
            )}
          </span>
        </>
      )}
    </Grid>
  );
}
